import { connect } from 'react-redux';
import { IApplicationState } from '../../../../../../../types/types';
import {
    getAuthUserSettingsCommentsSort
} from '../../../../../../../store/model/authUser/selectors/getAuthUserSettingsCommentsSort';
import { ICommentsHeaderHOCProps } from './types';
import { getCardComments } from '../../../../../../../store/model/selectors/getCardComments';
import { getUserChatId } from '../../../../../../../store/model/authUser/selectors/getIsUserChat';
import { onToggleChat } from './events/onToggleChat';
import { isShowChat } from 'app/store/model/authUser/selectors/isShowChat';
import { ICommentsHeaderEvents, ICommentsHeaderFields } from '../../components/CommentsHeader/types';
import { CommentsHeader } from '../../components/CommentsHeader/CommentsHeader';
import { onToggleOrder } from './events/onToggleOrder';

const mapStateToProps = (
    state: IApplicationState,
    { cardId }: ICommentsHeaderHOCProps
): ICommentsHeaderFields => {
    return {
        isChat: !!getUserChatId(state, cardId),
        isShowChat: getCardComments(state, cardId).length > 0 && isShowChat(state),
        order: getAuthUserSettingsCommentsSort(state),
    };
};

const mapDispatchToProps = (
    dispatch: any,
    { cardId }: ICommentsHeaderHOCProps,
): ICommentsHeaderEvents => {
    return {
        onToggleChat: () => dispatch(onToggleChat(cardId)),
        onToggleOrder: () => dispatch(onToggleOrder(cardId)),
    };
};

export const CommentsHeaderHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(CommentsHeader);

CommentsHeaderHOC.displayName = 'CommentsHeaderHOC';
